import moment from "moment";
import _ from "lodash";

export const getLocalDT = (time) => {
  var localDT = " ";
  if (!_.isEmpty(time)) {
    let gmtDateTime = moment.utc(time, "YYYY-MM-DD hh:mmA");
    localDT = gmtDateTime.local().format("YYYY-MM-DD h:mm A");
  }
  return localDT;
};

export const formatSecondsForLongDisplay = (seconds) => {
  return new Intl.DateTimeFormat("en", {
    dateStyle: "long",
    timeStyle: "long",
  }).format(new Date(seconds * 1000));
};

export const formatSecondsForDate = (seconds) => {
  let gmtDateTime = moment.utc(new Date(seconds * 1000), "MM/DD/YYYY hh:mmA");
  return gmtDateTime.local().format("MMM DD, YYYY");
};


export const formatSecondsForDateOnly = (seconds) => {
  let gmtDateTime = moment.utc(new Date(seconds * 1000), "MM/DD/YYYY hh:mmA");
  return gmtDateTime.local().format("MM/DD/YYYY");
};

export const calculateDateDifInDays = (dateA, dateB) => {
  const a = moment(dateA);
  const b = moment(dateB);

  return a.diff(b, "days") + 1;
};

const API_DATE_FORMATS = [
  "YYYY-MM-DD",
  "MMM D, YYYY",
  "MMM DD, YYYY",
  "MM/DD/YYYY",
  "M/D/YYYY",
  moment.ISO_8601,
];

export const formatDateForApiRequest = (value) => {
  if (value == null || value === "") {
    return null;
  }
  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }
    return moment
      .utc({
        year: value.getFullYear(),
        month: value.getMonth(),
        date: value.getDate(),
      })
      .format("YYYY-MM-DD");
  }
  const strict = moment.utc(value, API_DATE_FORMATS, true);
  if (strict.isValid()) {
    return strict.format("YYYY-MM-DD");
  }
  const loose = moment.utc(value, API_DATE_FORMATS);
  if (loose.isValid()) {
    return loose.format("YYYY-MM-DD");
  }
  const fallback = moment.utc(value);
  return fallback.isValid() ? fallback.format("YYYY-MM-DD") : null;
};


// WEBPACK FOOTER //
// ./src/layout/utils/timeUtils.js